import { Component, OnInit, Input, Optional } from '@angular/core';
import { PizzaDTO } from 'src/app/shared/model/dto/PizzaDTO';
import { PizzaPage } from '../pizza.page';
import { AdditionalToppingsPage } from '../additional-toppings/additional-toppings.page';
import { ShoppingCartService } from 'src/app/core/services/shoppingCart.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'pizza-footer',
	templateUrl: './footer.page.html',
	styleUrls: ['./footer.page.scss'],
})
export class FooterPage implements OnInit {
	@Input() size: PizzaDTO;
	@Input() toppings: boolean;
	@Input() showTotal: boolean;
	// No modal de toppings a página não está na cadeia de injectors (Ionic 6+
	// monta o modal fora da árvore da página) — ela chega por input.
	@Input() pizzaPage: PizzaPage;

	additionalToppings = [];
    howManyFlavorsToSelect = '';
    totalFlavorsQtty = 0;

	constructor(@Optional() private pizzaPageDI: PizzaPage,
				@Optional() private toppingsPage: AdditionalToppingsPage,
                private shoppingCartService: ShoppingCartService,
                private translate: TranslatePipe
    ) { }

	ngOnInit() {
		if (!this.pizzaPage) this.pizzaPage = this.pizzaPageDI;
		this.additionalToppings = this.pizzaPage.additionalToppings;

		this.size.selectedFlavors.forEach(flavor => {
			flavor.fractionText = this.flavorFractionText(flavor);
        });

        this.setFlavorsMessage();
    }

	flavorFractionText(flavor) {
		let totalFlavorsSelectedCount = this.size.qttyOfFlavorsSelected;
		let reducedFraction = this.shoppingCartService.reduceFraction([flavor.quantity, totalFlavorsSelectedCount])
		return `${reducedFraction[0]}/${reducedFraction[1]}`
    }
    
	countTotalFlavorsQuantitySelected() {
		this.totalFlavorsQtty = this.size.selectedFlavors.reduce((total, flavor) => {
			return total + flavor.quantity;
        }, 0);

        return this.totalFlavorsQtty;
    }    
    

	finishToppings(){
		this.toppingsPage.finishToppings()
	}

	nextPizzaPage(){
		this.pizzaPage.next();
		this.setFlavorsMessage();
	}

	setFlavorsMessage(){
		// Mesma armadilha do footer de pizza-nep: a PizzaPage injetada nem sempre é a página
		// que está na tela. Quando este footer é renderizado dentro do modal de adicionais, o
		// modal nasce do ModalController do injector do módulo, então o Angular resolve
		// PizzaPage pelo provider de módulo (FooterPageModule.providers) e entrega uma
		// instância novinha — cujo ngOnInit nunca rodou e que, portanto, não tem currentSize.
		// Era o maior erro de código nosso em produção (telemetria 27/07/2026: ~1.657 eventos
		// em ~1.541 devices num dia, sempre neste ponto, via ngOnInit). O allSet() abaixo já
		// se defendia disso; aqui faltava. Sem tamanho não há o que dizer sobre sabores:
		// mantemos a mensagem como está em vez de interpolar undefined e exibir
		// "Escolha entre  e  sabores".
		const currentSize = this.pizzaPage?.currentSize;
		if (!currentSize) return;

		this.howManyFlavorsToSelect = this.translate.transform('Choose between min and max flavors', {min: currentSize.minFlavors, max: currentSize.maxFlavors});
        if (currentSize.minFlavors == currentSize.maxFlavors) {
            this.howManyFlavorsToSelect = this.translate.transform('Choose x flavors', {x: currentSize.minFlavors});
        }
        if (currentSize.minFlavors == 1 && currentSize.maxFlavors > 1) this.howManyFlavorsToSelect = this.translate.transform('Choose up to x flavors', {x: currentSize.maxFlavors});
	}

	allSet(): boolean {
		if(this.pizzaPage.currentSize && this.pizzaPage.currentSize.crust && (!this.size.crust || !this.size.crust.id)) return false;
		if(this.pizzaPage.currentSize && this.pizzaPage.currentSize.dough && (!this.size.dough || !this.size.dough.id)) return false;
        if(this.size.maxFlavors == 0) return false;
		if(this.size.maxFlavors && this.size.priceBehavior == 'incremental' &&!(this.size.qttyOfFlavorsSelected == this.size.maxFlavors))
			return false;
    
        if(this.size.priceBehavior != 'incremental' && this.size.qttyOfFlavorsSelected < this.size.minFlavors) return false;

		return true;
	}
}
